<!-- 首屏 -->
<template>
  <div :class="$style.hero">
    <!-- 顶栏 -->
    <the-toolbar style="z-index: 1; position: relative; margin-bottom: 6.15rem" @login="onLogin" />
    <!-- 导航栏 -->
    <the-tabs
      ref="nav"
      :active-tab="activeTab"
      @tab-click="onTabClick"
      style="position: absolute; bottom: -0.75rem; left: 0"
    />
  </div>
</template>

<script>
import TheToolbar from '@/components/TheToolbar'
import TheTabs from '@/components/TheTabs'

export default {
  name: 'TheHero',
  components: { TheToolbar, TheTabs },
  props: {
    activeTab: {
      type: Number,
      default: 1
    }
  },
  methods: {
    onTabClick(tabIndex) {
      // 触发父组件的tab点击事件
      this.$emit('tab-click', tabIndex)
    },
    onLogin() {
      this.$emit('login')
    }
  }
}
</script>

<style lang="less" module>
.hero {
  .background-fill('./images/hero-bg.jpg');

  z-index: 1;
  position: relative;
  height: 15.04rem;
  background-size: 100% 100%;
}
</style>
